import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { localeStore } from '~/mobx/localesStore';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

export const OrderProductsDonation: FC = memo(
  observer((): ReactElement | null => {
    const { store: orderStore } = useOrderStoreContext();
    const findDonation: boolean = Boolean(orderStore.order?.products?.some((item) => item.is_donation));

    if (!findDonation) return null;

    return (
      <div className="order-products-donation">
        <p className="order-products-donation__title">{localeStore.t('donation')}</p>

        <p className="order-products-donation__price text-nowrap">
          {orderStore.order ? orderStore.formatPrice(orderStore.order.donation_subtotal || 0) : <Skeleton width={60} />}
        </p>
      </div>
    );
  })
);
